<script>
import $ from 'jquery'
import { localstorage } from '../mixins/localstorage'
import {useEmitter} from '@nguyenshort/vue3-mitt'

import Newsletter from '../common/components/newsletter/Newsletter'
import Newsfeed from '../common/components/Newsfeed'
import PageHeader from './PageHeader'
import PageLandingFioul from '../pages/node-landing-fioul/PageLandingFioul'
import PageLandingCereal from '../pages/node-landing-cereal/PageLandingCereal'
import PageFAQ from "../pages/node-faq/PageFAQ";
import PageAideContact from "../pages/node-aide-contact/PageAideContact";
import { onMounted, ref, reactive } from 'vue';

export default {
  name: "Page",
  components: {
            Newsfeed,
            Newsletter,
            PageHeader,
            PageLandingFioul,
            PageLandingCereal,
            PageFAQ,
            PageAideContact
  },
  setup(){
    const { checkLS } = localstorage.methods;
    const emitter = useEmitter()
    const popinTotal = 4;
    const displayForm = ref(false);
    const formEl = ref(null);
    const email = ref('');
    const newsletter = ref(null)
    const newsletterForm = reactive({
      displayForm,
      formEl,
      email
    });
      const dispatchPopin = (newEmail) => {
          newsletterForm.email = newEmail
          togglePopin(true, true)
      }
      const togglePopin = (state = true, force = false) => {

          const toggle = (s) => {
            newsletter.value.togglePopin(s)
          }
          if (checkLS() && !force) {

              // Get popin infos, or create them
              let popin = JSON.parse(localStorage.getItem('newsletterPopin')) || { time: null, step: 0, total: 0, status: 'in' }
              // Popin is obsolete if was displayed more than 1 day ago (or never shown)
              let popinObsolete = popin.time == null || (Date.now() - popin.time) > 24*60*60*1000 // Date.now() is in milliseconds
              // Show popin ?
              let showPopin = popin.status === 'in' && popinObsolete && popin.step > 0

              // If popin obsolete, count the step (don't show on first page display)
              if(popinObsolete){
                popin.step += 1
              }
              // Open popin if form was posted, or if popin needs to be shown
              toggle( popin.status === 'posted' || showPopin)

              // If not "out" (popin showed up too many times), modify local storage informations
              if(showPopin) {
                  // Change popin display date
                  popin.time = Date.now()
                  // Set number of times the popin was shown
                  popin.total = popin.total < popinTotal ? popin.total + 1 : popin.total
                  // Set step back to 0
                  popin.step = 0
                  // Don't display popin anymore (set status to "out") when shown too much times
                  popin.status = popin.total === popinTotal ? 'out' : 'in'
              }
              localStorage.setItem('newsletterPopin', JSON.stringify(popin))
          } else {
              toggle(state)
          }
      }
      const updateDataLayer = () => {
        $(document).ready(function () {
          const pagetypeExclude = ['Faq', 'AideEtContact'];
          window.dataLayer = window.dataLayer || [];
          var itemToPush = {};
          // Page title (pagename)
          var H1 = $('h1');
          if (H1.length) {
            itemToPush['pagename'] = H1.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          } else if (window.location.pathname === "/" || window.location.pathname === "" ){
            itemToPush['pagename'] = "Accueil"
          } else if (window.location.pathname === '/user'){
            itemToPush['pagename'] = "user"
          } else if (window.location.pathname === '/user/login'){
            itemToPush['pagename'] = "use_login"
          } else if (window.location.pathname === '/pro') {
            itemToPush['pagename'] = "Page_accueil_pro"
          }

          const pathsToMatch = ["/questions-reponses", "/aide-et-contact", "/pro"];

          // Breadcrumb (page_chapter)
          var breadcrumbs = $('.breadcrumbs');
          if (breadcrumbs && window.location.pathname !== '/nous-contacter') {
            $(breadcrumbs).each(function () {
              $(this).find('li a').each(function (index) {
                if (index === 0){
                  // we do not care about the breadcrumb first item; it will always be the homepage
                  return;
                }
                var link = $(this);
                var text = link.text().trim().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                if (text.length <= 1) {
                  text = link.attr('href').replace('/', '');
                  // if (text.length === 0) {
                  //   text = "accueil";
                  // }
                }
                var key = 'page_chapter' + (index);
                itemToPush[key] = text;
              });
            });
          }

          // pagetype / publication_date
          if ($('.publication_date').length && window.location.pathname !== '/nous-contacter') {
            itemToPush['publication_date'] = $('.publication_date').text()+'T00:00:00Z';
          }

          var pagetype = null;
          if (window.location.pathname === '/' || window.location.pathname === '') {
            pagetype = 'Accueil';
          } else if (window.location.pathname === '/pro') {
            pagetype = 'PagePro';
          } else if (window.location.pathname === '/user'){
            pagetype = 'Login';
          } else if (window.location.pathname === '/user/login'){
            pagetype = 'Login';
          } else if ($('#st-faq').length) {
            pagetype = 'Faq';
          } else if ($('[class^="landing"]').length) {
            pagetype = 'Landing page';
          } else if ($('.page-404__content').length) {
            pagetype = 'Erreur';
          } else if ($('.maintenance-msg').length) {
            pagetype = 'Maintenance';
          } else if (window.location.pathname === '/nous-contacter') {
            pagetype = 'Contact';
          } else if (window.location.pathname === '/aide-et-contact') {
            pagetype = 'AideEtContact';
          } else if ($('.publication-date').length && window.location.pathname !== '/nous-contacter') {
            itemToPush['publication_date'] = $('.publication-date').attr('date')+'T00:00:00Z';
          }

          if(pagetype === null) {
            pagetype = drupalSettings.antargaz_custom.node_type
          }
          itemToPush['pagetype'] = pagetype;
          itemToPush['event'] = "page_load";
          if(!pagetypeExclude.includes(pagetype)){
            window.dataLayer.push(itemToPush);
          }

        });
        // Push events
        // Header
        if($('header.page-header .region-header').length){
          var links = $('header.page-header .region-header a').add('.page-header__logo');
          links.each(function(index){
            $(this).click(function(e){
              var clicktype = 'navigation';
              var link = $(this);
              var text = link.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              var download = link.attr('download');
              var href = link.attr('href');
              var domain = href.match(/^https:\/\/[^/]+/);
              if(domain && domain[0].length && domain[0] !== 'https://antargaz.fr'){
                clicktype = 'exit';
              }else if(typeof download !== 'undefined'){
                clicktype = 'download';
              }
              if(text.length == 0){
                // Social media links without text
                if(link.parent('.menu-header-menu__social-media').length){
                  text = link.find('img').attr('title');
                }
              }
              // Text for Logo
              if(link.hasClass('page-header__logo')){
                text = 'Logo_antargaz';
              }
              window.dataLayer.push({
                'event': 'click',
                'click': text,
                'click_type': clicktype,
                'event_location': 'header'
              })
            });
          });
        }

        // Footer
        if($('footer').length){
          var links = $('footer a');
          links.each(function(index){
            $(this).click(function(e){
              var clicktype = 'navigation';
              var link = $(this);
              var text = link.text();
              var download = link.attr('download');
              var href = link.attr('href');
              var domain = href.match(/^https:\/\/[^/]+/);
              if(domain && domain[0].length && domain[0] !== 'https://antargaz.fr'){
                clicktype = 'exit';
              }else if(typeof download !== 'undefined'){
                clicktype = 'download';
              }
              if(text.length === 0){
                // If no text find an image
                var img = link.find('img');
                if(img.length){
                  if(img.attr('title')){
                    text = img.attr('title');
                  }else if(img.attr('alt')){
                    text = img.attr('alt');
                  }
                }
              }
              var itemToPush = {
                'event': 'click',
                'click': text.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                'click_type': clicktype,
                'event_location': 'footer'
              };
              if (clicktype == 'navigation' && link.hasClass('menu-footer__link')){
                var index = 1;
                while(true){
                  if (link.closest('.menu-footer__item--' + index).length === 0){
                    break;
                  }

                  var parentLinkN = link.closest('.menu-footer__item--' + index).find('.menu-footer__link--' + index);
                  if (parentLinkN[0].className == link[0].className){
                    break;
                  }
                  window.location.pathname !== 'nous-contacter' ? itemToPush['click_chapter' + index] =  parentLinkN.text() : null;
                  index++;
                }
              }
              window.dataLayer.push(itemToPush);
            });
          });
        }
        // Content
        if($('.layout-content').length){
          var links = $('.layout-content a, .sticky--float a');

          links.each(function(index){
            $(this).click(function(e){
              var clicktype = 'navigation';
              var link = $(this);
              var text = link.text();
              var download = link.attr('download');
              var href = link.attr('href');
              var domain = href.match(/^https:\/\/[^/]+/);
              if(domain && domain[0].length && domain[0] !== 'https://antargaz.fr'){
                clicktype = 'exit';
              } else if (typeof download !== 'undefined'){
                clicktype = 'download';
              }
              window.dataLayer.push({
                'event': 'click',
                'click': text.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                'click_type': clicktype,
                'event_location': 'content'
              })

            });
          });
        }

        // Highlight bandeau
        if($('.menu-disclaimer').length){
          var menu = $('.menu-disclaimer');
          var link = $('.menu-disclaimer a');
          var bandeauCreation = '';
          if(menu.hasClass('rouge')){
            bandeauCreation = 'rouge';
          }
          if(menu.hasClass('vert')){
            bandeauCreation = 'vert';
          }
          var bandeauUrl = link.attr('href');
          var bandeauName = link.text();
          // Push on display (page load)
          pushHighlight('highlight_impression','bandeau','sticky', bandeauCreation, bandeauUrl, bandeauName);
        }

        // Highlight carousel
        if($('.page--homepage .hero-slider').length){

          var buttons = $('.page--homepage .hero-slider .button--cta');
          buttons.each(function(index){
            var button = $(this);
            button.click(function(e){
              var slideIndex = button.closest('.swiper-slide').attr('data-swiper-slide-index');
              var carouselCreation  = 'position_' + (slideIndex + 1);
              var carouselUrl = button.attr('href');
              var carouselname = button.closest('.swiper-slide').find('.title.hero-title b').text();
              pushHighlight('highlight_click','carousel','top', carouselCreation, carouselUrl, carouselname);
            });
          })

        }
      }
      const pushHighlight = (event, category, placement, creation = '', url = '', name = '') => {
        window.dataLayer.push({
          'event': event,
          'onsitead_category': category,
          'onsitead_creation': creation,
          'onsitead_general_placement': placement,
          'onsitead_url': url,
          'onsitead_advertiser': name.replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
        })
      }
      onMounted(() => {
        togglePopin(true)
        emitter.on('dispatchNewsletter', (email) => dispatchPopin(email));
          updateDataLayer();
        if(document.getElementsByClassName("menu-disclaimer").length > 0) {
          if(window.innerWidth < 960) {
            document.getElementsByClassName("layout-content")[0].setAttribute("class","layout-content-disclaimer")
          }
        }
      })
      return {
        popinTotal,
        newsletter,
        newsletterForm,
        togglePopin,
        checkLS,
        dispatchPopin,
        updateDataLayer
      };
    }
    }
</script>

<style lang="sass">
@import ./../common/styles/settings
.page-form-unsubscribe #block-addtoanybuttons,
.page-form-satisfaction #block-addtoanybuttons,
.page-form-qualification #block-addtoanybuttons,
.page-landing-boat #block-addtoanybuttons,
.page-landing-fioul #block-addtoanybuttons
.page-landing-cereal #block-addtoanybuttons
    display: none
</style>
